// This function is used to redirect the user from a path that contains 'en-us' to 'us'.
// The reason for this redirection function was a request from the business for Stanford pages.
// credit-cards/offers/featured-cards
// credit-cards/offers/cash-back-cards
// credit-cards/offers/delta-skymiles-cards
// credit-cards/offers/hilton-cards

// nextState and replace are passed when using onEnter prop on the
// ModuleRoute component from the holocron-module-route package.
const redirectToUsRoute = (nextState, replace) => {
  const pathName = nextState.location.pathname;
  const queryParams = nextState.location.query;

  if (!pathName.includes('en-us')) {
    return;
  }

  // Check if the pathname contains 'en-us' and replace it with 'us'
  // This does not need to be case sensitive as the locals are always in lower case
  // Using replace to ensure the only thing that changes is the locale in the pathname

  const updatedPathName = pathName.replace('en-us', 'us');

  replace({
    pathname: updatedPathName,
    query: queryParams,
    state: null, // required even if not used.
  });
};

export default redirectToUsRoute;
